<template>
	<div>
		<flCabecalhoForm
			:msg="_traducao('global', 'obrigatorio')"
			cls="print-titulo-form-20"
			:texto="_traducao('global', 'contatoDeEmergencia')"
		/>

		<div class="row">
			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.nome_emergencia != ''}">
				<label><span class="no-print">* </span>{{ _traducao('global', 'nome') }}:</label>
				<input v-model="form.nome_emergencia" class="form-control input-sm" />
				<p class="help-block" v-show="erro.nome_emergencia != ''">{{ erro.nome_emergencia }}</p>
			</div>

			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.grau_emergencia != ''}">
				<label><span class="no-print">* </span>{{ _traducao('global', 'grauDeRelacionamento') }}:</label>
				<input v-model="form.grau_emergencia" class="form-control input-sm" />
				<p class="help-block" v-show="erro.grau_emergencia != ''">{{ erro.grau_emergencia }}</p>
			</div>

			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.telefone_emergencia != ''}">
				<label><span class="no-print">* </span>{{ _traducao('global', 'telefoneResidencial') }}:</label>
				<input v-model="form.telefone_emergencia" class="form-control input-sm" v-mask="_vtelefone" />
				<p class="help-block" v-show="erro.telefone_emergencia != ''">{{ erro.telefone_emergencia }}</p>
			</div>

			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.celular_emergencia != ''}">
				<label><span class="no-print">* </span>{{ _traducao('global', 'telefoneCelular') }}:</label>
				<input v-model="form.celular_emergencia" class="form-control input-sm" v-mask="_vtelefone" />
				<p class="help-block" v-show="erro.celular_emergencia != ''">{{ erro.celular_emergencia }}</p>
			</div>

			<div class="col-xs-12">
				<fl-endereco
					ref="endereco_emergencia"
					:tipo="'emergencial'"
					@dados-endereco-emergencia="
						(item) => {
							endereco_emergencia = item
						}
					"
				/>
			</div>
		</div>
	</div>
</template>
<script>
import flEndereco from '../../../../../components/endereco/main.vue'
export default {
	components: {flEndereco},
	data() {
		return {
			endereco_emergencia: '',
			form: {
				nome_emergencia: '',
				grau_emergencia: '',
				telefone_emergencia: '',
				celular_emergencia: ''
			},

			erro: {
				nome_emergencia: '',
				grau_emergencia: '',
				telefone_emergencia: '',
				celular_emergencia: ''
			}
		}
	},

	methods: {
		editar(item) {
			this.form.nome_emergencia = item.nome_emergencia
			this.form.grau_emergencia = item.grau_emergencia
			this.form.telefone_emergencia = item.telefone_emergencia
			this.form.celular_emergencia = item.celular_emergencia

			this.$refs.endereco_emergencia.editar({item: item, tipo: 'emergencial'})
		},

		validaForm() {
			let passou = true
			let obg = this._traducao('global', 'campoObrigatorio')

			if (this.form.nome_emergencia == '') {
				this.erro.nome_emergencia = obg
				passou = false
			} else {
				this.erro.nome_emergencia = ''
			}

			if (this.form.grau_emergencia == '') {
				this.erro.grau_emergencia = obg
				passou = false
			} else {
				this.erro.grau_emergencia = ''
			}

			if (this.form.telefone_emergencia == '') {
				this.erro.telefone_emergencia = obg
				passou = false
			} else {
				this.erro.telefone_emergencia = ''
			}

			if (this.form.celular_emergencia == '') {
				this.erro.celular_emergencia = obg
				passou = false
			} else {
				this.erro.celular_emergencia = ''
			}

			if (!this.$refs.endereco_emergencia.validaForm()) {
				passou = false
			}

			if (passou) {
				this.$emit('dados-contato-emergencial', {form: this.form, endereco: this.endereco_emergencia})
			}

			return passou
		}
	}
}
</script>